import * as React from 'react';

import PageComponent from '/Users/alvenqiu/Documents/porject/fpx-giws-web/src/pages/Billboard';

const PageComponentName = PageComponent;

export default PageComponentName;
